import config from 'helpers/config';
import fileClient from 'clients/fileClient';

/**
 * Download booking-voucher pdf file request for given id with provided filename.
 *
 * @param {number} id
 * @param {string} filename
 * @returns {Promise}
 */
export const downladBookingVoucherRequest = (id, filename) => {
    return fileClient.getPDF(`${ config.getApiBaseUrl() }/bookings/${ id }/voucher`, filename);
};

/**
 * Download booking-payment-slip pdf file request for given id with provided filename.
 *
 * @param {number} id
 * @param {string} filename
 * @returns {Promise}
 */
export const downloadBookingPaymentSlipRequest = (id, filename) => {
    return fileClient.getPDF(`${ config.getApiBaseUrl() }/bookings/${ id }/payment-slip`, filename);
};

/**
 * Download booking-invoice pdf file request for given id with provided filename.
 *
 * @param {number} id
 * @param {string} filename
 * @returns  {Promise}
 */
export const downloadBookingInvoiceRequest = (id, filename) => {
    return fileClient.getPDF(`${ config.getApiBaseUrl() }/bookings/${ id }/invoice`, filename);
};



// WEBPACK FOOTER //
// ./src/http/requests/bookings/bookingDownloadRequests.js